/**
 * DNH — StoryBriefModal (compatibility shim, deprecated).
 *
 * The Read-Brief popup was removed in favour of the standalone
 * `/briefs/:id` page. To avoid touching every caller, this shim now
 * immediately redirects to the standalone page when mounted and renders
 * nothing. New code should use <Link to={`/briefs/${id}`}> directly.
 *
 * `from` (optional `{ path, label }`) is forwarded as router state so
 * BriefDetail's "back" navigation returns to wherever the reader actually
 * came from (e.g. { path: "/reader", label: "Reader" }) instead of always
 * dropping them on the /briefs archive list.
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export function StoryBriefModal({ storyId, onClose, from }) {
  const navigate = useNavigate();
  const opened = useRef(null);
  useEffect(() => {
    if (storyId && opened.current !== storyId) {
      opened.current = storyId;
      navigate(`/briefs/${storyId}`, { state: { from, generate: true } });
    }
    // Tell parent to drop its modal state so a back-nav doesn't loop.
    if (typeof onClose === "function") onClose();
  }, [storyId, from, navigate, onClose]);
  return null;
}

export default StoryBriefModal;
